<template>
    <div>
        <b-card :header="$t('general.projects.progress.progress_total_execution_chart.title')" header-tag="h5" header-bg-variant="primary" class="shadow-none text-white">
            <bar-line-chart
                :chartSeries="progress_from_total_execution_value_estimated.calculation.chartSeries"
                :chartxAxis="progress_from_total_execution_value_estimated.calculation.chartxAxis"
                :chartLegend="progress_from_total_execution_value_estimated.calculation.chartLegend"
                :chartLoaded="chartsLoaded"
            >
            </bar-line-chart>
        </b-card>

        <b-card :header="$t('general.projects.progress.progress_current_available_chart.title')" header-tag="h5" header-bg-variant="primary" class="shadow-none text-white">
            <bar-line-chart
                :chartSeries="progress_from_current_available_execution_value.calculation.chartSeries"
                :chartxAxis="progress_from_current_available_execution_value.calculation.chartxAxis"
                :chartLegend="progress_from_current_available_execution_value.calculation.chartLegend"
                :chartLoaded="chartsLoaded"
            >
            </bar-line-chart>
        </b-card>

        <single-bar-chart
            :headerTitle="current_execution_value_work_drawings.headerTitle" 
            :chartSeries="current_execution_value_work_drawings.chartSeries"
            :chartxAxis="current_execution_value_work_drawings.chartxAxis"
            :chartLegend="current_execution_value_work_drawings.chartLegend"
            :chartLoaded="chartsLoaded"
        >
        </single-bar-chart>

        <line-chart 
            :headerTitle="progress_from_periodic_current_available_work_value.headerTitle"
            :headingSize="progress_from_periodic_current_available_work_value.headingSize" 
            :chartSeries="progress_from_periodic_current_available_work_value.chartSeries" 
            :lineData="progress_from_periodic_current_available_work_value.lineData"
            :chartLegend="progress_from_periodic_current_available_work_value.chartLegend"
            :chartLoaded="chartsLoaded"
        >
        </line-chart>
    </div>
</template>

<script>
import Vue from 'vue';
import BarLineChart from '@/components/pages/project/percent_progress/common/charts/bar_line_chart.vue';
import SingleBarChart from '@/components/pages/project/percent_progress/common/charts/single_bar_chart.vue';
import LineChart from '@/components/pages/project/percent_progress/common/charts/line_chart.vue';

export default {
    name: 'periodical_analysis_charts_other_discipline_insulation',
    components: {
        BarLineChart,
        SingleBarChart,
        LineChart,
    },
    props: {
        rowData: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            chartsLoaded: false,
            progress_from_total_execution_value_estimated: {
                calculation: {
                    chartSeries: [
                        {
                            name: Vue.i18n.translate('table.progress_week'),
                            type: 'bar',
                            xAxisIndex: 1,
                            yAxisIndex: 1,
                            data: []
                        }, 
                        {
                            name: Vue.i18n.translate('table.cummulated_progress'),
                            type: 'line',
                            data: [],
                            color: ['#C0504D'],
                        }
                    ],
                    chartSeriesAvailable: [
                        'progress_from_total_execution_calculation_progress_week',
                        'progress_from_total_execution_calculation_cummulated_progress',
                    ],
                    chartxAxis: [
                        {
                            type: 'category',
                            boundaryGap: true,
                            data: []
                        }, 
                        {
                            type: 'category',
                            boundaryGap: true,
                            data: []
                        }
                    ],
                    chartLegend: [ 
                        {
                            name: Vue.i18n.translate('table.progress_week'),
                        },
                        {
                            name: Vue.i18n.translate('table.cummulated_progress'),
                        }
                    ],
                },
            },
            progress_from_current_available_execution_value: {
                calculation: {
                    chartSeries: [
                        {
                            name: Vue.i18n.translate('table.progress_week'),
                            type: 'bar',
                            xAxisIndex: 1,
                            yAxisIndex: 1,
                            data: []
                        }, 
                        {
                            name: Vue.i18n.translate('table.cummulated_progress'),
                            type: 'line',
                            data: [],
                            color: ['#C0504D'],
                        }
                    ],
                    chartSeriesAvailable: [
                        'progress_from_current_available_calculation_progress_week',
                        'progress_from_current_available_calculation_cummulated_progress',
                    ],
                    chartxAxis: [
                        {
                            type: 'category',
                            boundaryGap: true,
                            data: []
                        }, 
                        {
                            type: 'category',
                            boundaryGap: true,
                            data: []
                        }
                    ],
                    chartLegend: [ 
                        {
                            name: Vue.i18n.translate('table.progress_week'),
                        },
                        {
                            name: Vue.i18n.translate('table.cummulated_progress'),
                        }
                    ],
                },
            },
            current_execution_value_work_drawings: {
                headerTitle: 'table.current_execution_value_work_drawings',
                chartSeries: [
                    {
                        name: Vue.i18n.translate('table.current_execution_value_work_drawings'),
                        type: 'bar',
                        data: [],
                        color: '#4a7ebb',
                    },
                ],
                chartSeriesAvailable: [
                    'current_execution_value_work_drawings',
                ],
                chartxAxis: [],
                chartLegend: [ 
                    {
                        name: Vue.i18n.translate('table.current_execution_value_work_drawings'),
                    }
                ],
            },
            progress_from_periodic_current_available_work_value: {
                headerTitle: Vue.i18n.translate('general.projects.progress.progress_from_periodic_current_available_work_value.title'),
                headingSize: 'h4',
                chartSeries: [
                    {
                        name: Vue.i18n.translate('table.percent_performed_value_calculation'),
                        type: 'line',
                        symbolSize: 8,
                        data: [],
                        color: '#4a7ebb',
                    },
                ],
                lineData: [],
                chartLegend: [
                    {
                        name: Vue.i18n.translate('table.percent_performed_value_calculation'),
                    },
                ],
            },
        }
    },
    mounted () {
        this.onLoadCharts();
    },
    methods: {
        onLoadCharts() {
            this.onLoadChart1();
            this.onLoadChart2();
            this.onLoadChart3();
            this.onLoadChart4();
            if (this.rowData.length > 0) {
                this.chartsLoaded = true;
            }
        },
        onLoadChart1 () {
            //Progress from Total Execution Value estimated
            this.rowData.forEach((field, idx) => {
                this.progress_from_total_execution_value_estimated.calculation.chartxAxis[0].data.push(field.step_calendar);
                this.progress_from_total_execution_value_estimated.calculation.chartxAxis[1].data.push(field.step_calendar);

                var that = this;
                Object.keys(field).forEach(function(key) {
                    if (that.progress_from_total_execution_value_estimated.calculation.chartSeriesAvailable[0] === key) {
                        that.progress_from_total_execution_value_estimated.calculation.chartSeries[0].data.push(field[key]);
                    }

                    if (that.progress_from_total_execution_value_estimated.calculation.chartSeriesAvailable[1] === key) {
                        that.progress_from_total_execution_value_estimated.calculation.chartSeries[1].data.push(field[key]);
                    }
                });
            });
        },
        onLoadChart2 () {
            //Progress from Current Available Execution Value
            this.rowData.forEach((field, idx) => {
                this.progress_from_current_available_execution_value.calculation.chartxAxis[0].data.push(field.step_calendar);
                this.progress_from_current_available_execution_value.calculation.chartxAxis[1].data.push(field.step_calendar);

                var that = this;
                Object.keys(field).forEach(function(key) {
                    if (that.progress_from_current_available_execution_value.calculation.chartSeriesAvailable[0] === key) {
                        that.progress_from_current_available_execution_value.calculation.chartSeries[0].data.push(field[key]);
                    }

                    if (that.progress_from_current_available_execution_value.calculation.chartSeriesAvailable[1] === key) {
                        that.progress_from_current_available_execution_value.calculation.chartSeries[1].data.push(field[key]);
                    }
                });
            });
        },
        onLoadChart3 () {
            //Current Execution Value Work Drawings
            this.rowData.forEach((field, idx) => {
                this.current_execution_value_work_drawings.chartxAxis.push(field.step_calendar);
                var that = this;
                
                Object.keys(field).forEach(function(key) {
                    if (that.current_execution_value_work_drawings.chartSeriesAvailable[0] === key) {
                        that.current_execution_value_work_drawings.chartSeries[0].data.push(field[key]);
                    }
                });
            });
        },
        onLoadChart4 () {
            //Progress from Periodic Current Available Work Value
            this.rowData.forEach((field, idx) => {
                this.progress_from_periodic_current_available_work_value.lineData.push(field.step_calendar);
                this.progress_from_periodic_current_available_work_value.chartSeries[0].data.push(field.percent_performed_value_calculation);
            });
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/project/percent_progress/other_discipline/insulation/periodical_analysis/periodical_analysis_charts_other_discipline_insulation.vue